/**
 Author - Muhamed Afsal
 Git - https://bitbucket.org/mohdafsal/
 **/

import React from "react";
import styled, {css} from "styled-components";

const SliderArrows = ({className, onClick, type}) => {
  return (
    <Button type={type} onClick={onClick}>
      <ButtonIcon type={type} />
    </Button>
  );
};

const Button = styled.button`
  border-radius: 50%;
  width: 30px;
  height: 30px;
  background: #fff;
  border: 2px solid #191246;
  position: absolute;
  cursor: pointer;
  ${props => props.type} : -5%;
  top: 50%;
  @media (max-width: 48em) {
    display: none;
  }
`;

const ButtonIcon = styled.span`
  border: solid #191246;
  border-width: 0 2px 2px 0;
  border-radius: 2px;
  display: inline-block;
  padding: 3px;
  position: relative;
  ${props => props.type === "right" &&
      css`
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
    right: 2%;
  `};
  ${props => props.type === "left" &&
      css`
    transform: rotate(135deg);
    -webkit-transform: rotate(135deg);
    left: 4%;
  `};
`;

export default SliderArrows;
